// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wlnt","fullView":"styles_fullView__3ubMC"};